var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVscodeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HOSPITAL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.307,
    y: 52.533,
    width: 115.386,
    height: 69.16,
    fill: "#c8effe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.503,
    y: 62.592,
    width: 17.131,
    height: 9.789,
    fill: "#62dbfb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.366,
    y: 62.592,
    width: 17.131,
    height: 9.789,
    fill: "#62dbfb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.322 32.684 68.322 23.817 77.188 23.817 77.188 15.174 68.322 15.174 68.322 6.307 59.678 6.307 59.678 15.174 50.811 15.174 50.811 23.817 59.678 23.817 59.678 32.684 68.322 32.684",
    fill: "#f07281"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.497,
    y: 32.684,
    width: 61.006,
    height: 89.009,
    fill: "#dff6fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.556,
    y: 42.743,
    width: 40.888,
    height: 9.789,
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.556,
    y: 62.592,
    width: 40.888,
    height: 9.789,
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.556,
    y: 89.945,
    width: 40.888,
    height: 31.748,
    fill: "#99e6fc"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.307,101.785a1.75,1.75,0,0,0,1.75-1.75v-4.5a1.75,1.75,0,0,0-3.5,0v4.5A1.75,1.75,0,0,0,6.307,101.785Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.693,50.783h-9.5a1.75,1.75,0,0,0,0,3.5h7.752v65.66H96.253V74.131h15.381a1.751,1.751,0,0,0,1.75-1.75V62.592a1.751,1.751,0,0,0-1.75-1.75H96.253V54.283h6.575a1.75,1.75,0,0,0,0-3.5H96.253v-18.1a1.751,1.751,0,0,0-1.75-1.75H70.072V25.567h7.116a1.749,1.749,0,0,0,1.75-1.75V15.174a1.75,1.75,0,0,0-1.75-1.75H70.072V6.307a1.751,1.751,0,0,0-1.75-1.75H59.678a1.751,1.751,0,0,0-1.75,1.75v7.117H50.811a1.751,1.751,0,0,0-1.75,1.75v8.643a1.75,1.75,0,0,0,1.75,1.75h7.117v5.367H33.5a1.751,1.751,0,0,0-1.75,1.75v18.1H6.307a1.75,1.75,0,0,0-1.75,1.75V85.88a1.75,1.75,0,0,0,3.5,0v-31.6h23.69v6.559H16.366a1.751,1.751,0,0,0-1.75,1.75v9.789a1.751,1.751,0,0,0,1.75,1.75H31.747v45.812H8.057v-10.67a1.75,1.75,0,0,0-3.5,0v12.42a1.751,1.751,0,0,0,1.75,1.75H121.693a1.751,1.751,0,0,0,1.75-1.75V52.533A1.75,1.75,0,0,0,121.693,50.783ZM109.884,64.342v6.289H96.253V64.342ZM59.678,22.067H52.561V16.924h7.117a1.751,1.751,0,0,0,1.75-1.75V8.057h5.144v7.117a1.75,1.75,0,0,0,1.75,1.75h7.116v5.143H68.322a1.75,1.75,0,0,0-1.75,1.75v7.117H61.428V23.817A1.751,1.751,0,0,0,59.678,22.067ZM18.116,70.631V64.342H31.747v6.289Zm17.131-36.2H92.753v85.509H86.194v-30a1.751,1.751,0,0,0-1.75-1.75H43.556a1.751,1.751,0,0,0-1.75,1.75v30H35.247ZM65.75,91.7H82.694v28.248H65.75Zm-3.5,28.248H45.306V91.7H62.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.556,54.283H84.444a1.751,1.751,0,0,0,1.75-1.75v-9.79a1.751,1.751,0,0,0-1.75-1.75H43.556a1.751,1.751,0,0,0-1.75,1.75v9.79A1.751,1.751,0,0,0,43.556,54.283Zm1.75-9.79H82.694v6.29H45.306Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.556,74.131H84.444a1.751,1.751,0,0,0,1.75-1.75V62.592a1.751,1.751,0,0,0-1.75-1.75H43.556a1.751,1.751,0,0,0-1.75,1.75v9.789A1.751,1.751,0,0,0,43.556,74.131Zm1.75-9.789H82.694v6.289H45.306Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeIcon);
export default __webpack_public_path__ + "static/media/vscode-icon.f7a279121e31535f2ae2230ad83f797a.svg";
export { ForwardRef as ReactComponent };